// src/App.js
import React from "react";
import AppRouter from "./routes/AppRouter";
import { BrowserRouter as Router } from "react-router-dom";
import { CartProvider } from "./context/CartContext";

function App() {
  return (
    <Router>
      <CartProvider>
        <AppRouter />
      </CartProvider>
    </Router>
  );
}

export default App;